import styled from 'styled-components';
import { Progress } from 'antd';

import { colours } from 'utils/theme';
import { useWindowWidth } from 'hooks';
import { Icon, Tooltip } from 'components/common';

import Stat from '../Stat';
import { StatTitle } from '../styled';

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  ${p => p.theme.breakpoint.smallTablet} {
    margin-left: 90px;
    justify-content: center;
  }
  ${p => p.theme.breakpoint.mobile} {
    margin-left: 0px;
    flex-wrap: wrap;
    flex: 0;
  }
`;

const Stats = props => {
  const { isMobile, isSmallLaptop } = useWindowWidth();

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Stat
          label={`Contacts`}
          value={props.researchersMatched}
          color={colours.researchers}
          total={props.totalResearchers}
        />
        <Stat
          label={`Funding\nAwards`}
          value={props.grantsMatched}
          color={colours.grants}
          total={props.totalGrants}
        />
        <Stat
          label={`Tradeshow\nSessions`}
          color={colours.posters}
          value={props.sessionsMatched}
          total={props.totalSessions}
        />
      </div>
      <div style={{ display: 'flex' }}>
        <Stat
          label={`Published\nArticles`}
          color={colours.publications}
          value={props.publicationsMatched}
          total={props.totalPublications}
        />
        <Stat
          label={`Clinical\nTrials`}
          color={colours.trials}
          value={props.clinicalTrialsMatched}
          total={props.totalClinicalTrials}
        />
        <Tooltip
          title={
            props.descriptionMatched
              ? 'Search Matched Organisation Description Field'
              : 'Search Not Matched Organisation Description Field'
          }
          placement='top'
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Progress
              format={() =>
                props.descriptionMatched ? (
                  <Icon icon='check' size='lg' color='#52C41A' />
                ) : (
                  <span
                    style={{
                      fontSize: isSmallLaptop ? 14 : 18,
                      fontWeight: 500,
                    }}
                  >
                    0
                  </span>
                )
              }
              type='circle'
              width={isMobile ? 45 : isSmallLaptop ? 45 : 60}
              percent={0}
              style={{
                padding: isMobile
                  ? '0 5px'
                  : isSmallLaptop
                  ? '0 10px'
                  : '0 15px',
              }}
              status='normal'
            />
            <StatTitle>{`Org\nDescription`}</StatTitle>
          </div>
        </Tooltip>
      </div>
    </Container>
  );
};

export default Stats;
